import { atom } from 'recoil'
import { persistAtom } from '../persist'

export const messageBarOpenState = atom<boolean>({
  key: 'messageBarState',
  default: true,
  effects_UNSTABLE: [persistAtom],
})

export const messageState = atom<string | undefined>({
  key: 'messageState',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
})

export const errorMessageState = atom<string | undefined>({
  key: 'errorMessageState',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
})
